import ButtonIcon from "../../button"
import { React, useState, useRef, useEffect } from 'react';
import "./filter-button.component.css";
import { ORFButton } from "../forms/order-request-form.component";
import { REQUEST_TYPE } from "../../../constants/external-constants";
import Icons from "../../icon"

const FilterButton = ({ filterData, filtersub, filerCheckboxSub, fetchFilterData, requestLog, setTableLength, searchFilterData, tableLength, searchValue, clearSearhValue }) => {
    let myRef = useRef(null);
    const [showItem, setShowItem] = useState(false)
    const [mainActive, setmainActive] = useState(false)
    const [showList, setShowList] = useState(false)
    const [selectedList, setSelectedList] = useState("")
    const [filterBy, setFilterBy] = useState("")
    const [getRequest, setGetRequest] = useState("")
    const [request, setRequest] = useState("")
    const [checkList, setCheckList] = useState([])
    const href = window.location;
    const [subShowList, setSubShowList] = useState(false)
    const handleClickOutside = (event) => {
        if (myRef.current && !myRef.current.contains(event.target)) {
            setShowItem(false)
            setShowList(false)
            setSubShowList(false)
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });



    useEffect(() => {
        setRequest(getRequest);
    }, [getRequest])

    function forApprovalData() {
        const data = requestLog.orderApprovalData.Data.Items.map((item) => ({ Key: item.RequestTypeId, Value: item.RequestType }))
        return data;
    }
    //get the request url
    function getPath() {
        let parts = href.pathname.split('/');
        let lastSegment = parts.pop() || parts.pop();
        return lastSegment;
    }

    function requestedTab() {

        let location = getPath();

        if (location === REQUEST_TYPE.orderRequest) {

            setTableLength(requestLog?.orderRequestData?.Data?.Items.length)
        }
        if (location === REQUEST_TYPE.quotationRequest) {

            setTableLength(requestLog?.orderQuotationData?.Data?.Items.length)
        }
        if (location === REQUEST_TYPE.approvalRequest) {

            setTableLength(requestLog?.orderApprovalData?.Data?.Items.length)
        }
        if (location === REQUEST_TYPE.coverageRequest) {

            setTableLength(requestLog?.orderCoverageData?.Data?.Items.length)
        }
        
    }

    function replaceSubData(target) {
        const array = [{ Key: 4, Value: 'New Quotation Request' }, { Key: 5, Value: 'Upgrade Quotation Request' }]
        return target = array;
    }
    function filterFunctiion(el) {
        //fetchFilterData(el.target.innerText);
        setShowList(!showList);
        setShowItem(!showItem);
        requestedTab();
    };

    function subFilterFunction() {
        if (!showList) {
            var selectedFilter = filterData.filter(value => value.subFilterTitles.includes(request))[0].filterTitle;
            fetchFilterData(selectedFilter);
            setFilterBy(selectedFilter);
            setGetRequest(selectedFilter)
        }

        setShowList(!showList);
        setSubShowList(!subShowList);
    }

    function clearCheckbox() {
        document.querySelectorAll('.custom-filter-item input[type=checkbox]').forEach(el => el.checked = false);
        setmainActive(false);
        setCheckList("")
        setSelectedList("")

    }

    function displayItem() {
        setShowItem(!showItem)
    }
    
    function displaySubData(options) {
        if (getPath() === REQUEST_TYPE.quotationRequest && request === REQUEST_TYPE.request) {
            
            options = replaceSubData(options);
        }
        if (getPath() === REQUEST_TYPE.approvalRequest && request === REQUEST_TYPE.request) {
            options = forApprovalData();
        }

        var liOptions = options.filter((value, index, self) =>
            index === self.findIndex((t) => (
                t.Key === value.Key || t.Value === value.Value
            ))
        ).map((subItem) => {
            return <li key={subItem.Key} onClick={(e) => searchFilterData(e, filterBy)} data-value={subItem.Value} data-id={JSON.stringify(subItem)}><a href="#" >{subItem.Value}</a></li>
        });

        if (getPath() === REQUEST_TYPE.orderRequest && request === REQUEST_TYPE.request) {
            var lastId = options.length > 0 ? Math.max(...options.map(v => v.Key)) + 1 : 0;
            var liOther = filterData.filter((value) => value.filterTitle === request).map((item) => {
                var subs = item.subFilterTitles.map((subTitle) =>
                    <li className="sub-item-list" key={lastId} onClick={subFilterFunction} >
                        <a href="#" onClick={selectFilter}>{subTitle}</a>
                    </li>);
                return subs;
            });
            liOptions = [...liOptions, liOther];
        }

        return liOptions;

    }

    function selectFilter(el) {
        let selectedFilter = el.target.innerText;
        fetchFilterData(selectedFilter);
        setFilterBy(selectedFilter);
        setGetRequest(selectedFilter)
      /* innerText setSelectedList(el.target.)*/
    }

    function clearLabel() {
        setSelectedList("")
        setCheckList("")

        var checkboxes = document.querySelectorAll('.custom-filter-sub input[type=checkbox]')
        if (checkboxes !== null) {
            for (var x = 0; x < checkboxes.length; x++) {
                checkboxes[x].checked = false
            }
        }

    }

    function getCheckValue(el) {
        const all_Values = [];
        var checkboxes = document.querySelectorAll('.custom-filter-sub input[type=checkbox]:checked')
        for (var i = 0; i < checkboxes.length; i++) {
            all_Values.push(checkboxes[i].value)
            setCheckList(all_Values)
        }
        setSelectedList(all_Values.join(","))
    }

    window.onpopstate = function () {
        const listItem = document.querySelector(".filter-button-container .custom-filter-sub.custom-filter-check")
        if (listItem !== null) {
            if (checkList.length !== 0) {
                for (var i = 0; i < checkList.length; i++) {
                    var checkboxes = document.querySelectorAll('.custom-filter-sub input[type=checkbox]')
                    for (var x = 0; x < checkboxes.length; x++) {
                        if (checkboxes[x].value === checkList[i]) {
                            checkboxes[x].checked = true
                        }
                    }
                }
            }
        }
    }
    return (
        <div className="filter-button-container" ref={myRef}>
            <ButtonIcon onClick={displayItem} iconLeft="filter" iconSize="14px" customClassName="request-header-filter-button" clearSearhValue={clearSearhValue} searchValue={searchValue} showFilter={true} labelName={selectedList !== "" ? selectedList : "Filter"} />
            {selectedList !== "" ?
                <Icons
                    name="x-solid"
                    size="10px"
                    customClassName="icon-right"
                    onClick={clearLabel}
                />
                : ""}

            {showItem?
                <ul className="custom-filter-item">
                    {filterData.map((item, id) =>
                        <li key={id} onClick={filterFunctiion} >
                            <a href="#" onClick={selectFilter}>{item.filterTitle}</a>
                        </li>
                    )}
                </ul>
                : ""}

            {showList ?
                <ul className="custom-filter-item custom-filter-sub">
                    <li key="0"><span onClick={filterFunctiion}><a href="#">{request}</a></span></li>
                    
                   
                    {tableLength > 0 && filtersub.length > 0 ? displaySubData(filtersub)
                     : ""}
                   
                </ul>
                :
                ""
            }

            {subShowList ?
                <ul className="custom-filter-item custom-filter-sub">
                    <li key="0"><span onClick={subFilterFunction}><a href="#">{request}</a></span></li>
                    

                    {tableLength > 0 && filtersub.length > 0 ? displaySubData(filtersub)
                        : ""}

                </ul>
                : 
                ""
            }

            {/*showList ? 
                <ul className="custom-filter-item custom-filter-sub custom-filter-check">     
                    <li>
                      <span onClick={filterFunctiion}><a href="#">Filter</a></span>
                      <a href="#" onClick={clearCheckbox} className="clear-checkbox">Clear Filter</a>
                    </li>
                    {filtersub.map((subItem)=>
                      <li key={subItem.key}><input type="checkbox" value={subItem.value} onChange={getCheckValue}/>{subItem.value}</li>                        
                    )} 
                    <li>
                        <ORFButton
                            label={"Apply Filter"}
                            variant={"primary"}
                        />  
                      </li>
                </ul>              
             : "" */}

        </div>
    )
}

export default FilterButton
